<app-ui-main-menu>
    <mat-card>
      <mat-card-header>
        <mat-card-title>Preços do Plano: {{ planName }}</mat-card-title>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content>
        <div class="actions">
          <div class="create">
            <button mat-raised-button color="accent" type="button" (click)="openCreatePriceModal()">
              Criar Novo Preço
            </button>
          </div>
          <div class="filters">
            <mat-form-field appearance="outline" class="filter-field">
              <mat-label>Pesquisar</mat-label>
              <input matInput placeholder="Pesquisar preços..." [(ngModel)]="search" [disabled]="isFilterApplied" />
            </mat-form-field>
            <button mat-raised-button color="primary" type="button" (click)="onSearch()" [disabled]="isFilterApplied">
              Pesquisar
            </button>
            <button *ngIf="isFilterApplied" mat-raised-button class="clear-button" type="button" (click)="clearFilters()">
              Limpar Filtros
            </button>
          </div>
        </div>
        <div class="table-container">
          <table class="prices-table">
            <thead>
              <tr>
                <th>Valor</th>
                <th>Criada em</th>
                <th>Ativar em</th>
                <th>Inativa em</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let price of prices" [ngClass]="{'inactive-price': !price.status}">
                <td>{{ price.price | currency }}</td>
                <td>{{ price.createdAt | dateBRPlanPrice }}</td>
                <td>{{ price.startDate | dateBRPlanPrice }}</td>
                <td>{{ price.inactivatedAt ? (price.inactivatedAt | dateBRPlanPrice) : '-' }}</td>
                <td>{{ price.status ? 'Ativo' : 'Inativo' }}</td>
                <td>
                  <button *ngIf="canDeletePrice(price)" mat-icon-button class="delete-button" (click)="deletePrice(price)" matTooltip="Excluir Preço">
                    <fa-icon [icon]="'trash-alt'"></fa-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination">
          <button *ngIf="page > 1" mat-stroked-button type="button" (click)="changePage(page - 1)">
            Anterior
          </button>
          <span>Página {{ page }}</span>
          <button mat-stroked-button type="button" (click)="changePage(page + 1)" [disabled]="prices.length < 20">
            Próxima
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </app-ui-main-menu>
  